import React, { useState, useEffect, useLayoutEffect } from 'react';
import Select from "react-select";
// import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as s from './Sidebar.styles';
import Icon from "react-crypto-icons";
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';

const Sidebar = props => {
  const [modalShowStep1, setModalShowStep1] = useState(false);
  const [modalShowStep2, setModalShowStep2] = useState(false);
  const [modalShowStep3, setModalShowStep3] = useState(false);
  const [selectedOption, setSelectedOption] = useState("USDT");
  const options = [
      {
        value: "USDT",
        label: (
          <div>
            <Icon name="usdt" className="mr-2" size={18}/> USDT
          </div>
        )
      },
      {
        value: "ETH",
        label: (
          <div>
            <Icon name="eth" className="mr-2" size={18}/> ETH
          </div>
        )
      },
      {
        value: "vanilla",
        label: (
          <div>
            <Icon name="matic" className="mr-2" size={18}/> MATIC
          </div>
        )
      }
  ];
  const handleTypeSelect = e => {
      setSelectedOption(e.value);
  };
  const handleMenuItemClick = (name, index) => {
      setSelectedMenuItem(name);
  }
  const menuItems = [
    {name:"Wrapped Bitcoin", to:"bitcoin", icon:"bitcoin"},
    {name:"Ethereum", to:"bitcoin", icon:"eth"},
    {name:"AAVE", to:"bitcoin", icon:"aave"},
    {name:"Compound", to:"bitcoin", icon:"compound"}
  ];
  const [selected, setSelectedMenuItem] = useState(menuItems[0].name);
  const menuItemsJSX = menuItems.map((item, index) => {
      return (
        <s.ItemContainer key={index}>
          <Link to={item.to} style={{ textDecoration: 'none' }}>
            <s.MenuItem
              selected={selected == item.name}
              onClick={() => handleMenuItemClick(item.name, index)}
            >
              <Icon name={item.icon} size={25} />
              <s.Text>{item.name}</s.Text>
            </s.MenuItem>
          </Link>
        </s.ItemContainer>
      )
  });
 
  function CreateAccountModal(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className='border-bottom-0'>
          <Modal.Title className='mx-auto mt-2' id="contained-modal-title-vcenter">
            Create Account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='px-5 py-5'>
          <Form.Label htmlFor="basic-url">Enter Referral ID Code</Form.Label>
          <Form.Control type="text" />
          <div className='mx-auto text-center mt-3'>
            <Button variant='primary' onClick={onClickForStep1} className="px-5 mt-4">Create Account</Button>
            <Form.Label htmlFor="basic-url" as="a" className='d-block mt-1 text-decoration-none' style={{cursor:'pointer', fontSize:'12px'}}>I don't have Referral ID code.</Form.Label>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  function CreateAccountModalStep2(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className='border-bottom-0'>
          <Modal.Title className='mx-auto mt-2' id="contained-modal-title-vcenter">
            Create Account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='px-5 py-5'>
          <Form.Label htmlFor="basic-url">Enter Discord your name or Email to get the code.</Form.Label>
          <Form.Control type="text" placeholder='Discord Namr/Email' />
          <div className='mx-auto text-center mt-1'>
            <Button variant='primary' onClick={onClickForStep2} className="px-5 mt-4">Get Code</Button>
          </div>
          <Form.Label htmlFor="basic-url">Enter the code.</Form.Label>
          <Form.Control type="text" placeholder='Code'/>
          <div className='mx-auto text-center mt-1'>
            <Button variant='secondary' onClick={onClickForStep2} className="px-5 mt-4">Submit</Button>
            <Form.Label htmlFor="basic-url" as="a" className='d-block mt-1 text-decoration-none' style={{cursor:'pointer', fontSize:'12px'}}>I have a Referral ID.</Form.Label>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  function CreateAccountModalStep3(props) {
    return (
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className='border-bottom-0'>
          <Modal.Title className='mx-auto mt-2' id="contained-modal-title-vcenter">
            Create Account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='px-5 py-5'>
          <Form.Label htmlFor="basic-url" className='px-5'>Choose coin and Amount, that you want to deposit to this Account</Form.Label>
          <div className='mx-auto text-center mt-3 px-3'>
            <InputGroup className="mt-3 mb-3">
                <Select value={options.filter(function(option) {
                        return option.value === selectedOption;
                    })} onChange={handleTypeSelect} options={options} />
                <Form.Control type="number" placeholder="450" />
            </InputGroup>
            <Button variant='primary' onClick={onClickForStep3} className="px-5 mt-4">Deposit</Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };
  const onClickForStep1 = () => {
    setModalShowStep1(false);
    setModalShowStep2(true);
  };
  const onClickForStep2 = () => {
    setModalShowStep2(false);
    setModalShowStep3(true);
  };
  const onClickForStep3 = () => {
    setModalShowStep3(false);
  };
  return (
  <s.SidebarContainer>
      <s.MenuItemContainer>
        {menuItemsJSX}
        <s.ItemContainer key={99999}>
          <Link to="#" style={{ textDecoration: 'none' }}>
            <s.MenuItem
              selected={selected == "new account"}
              onClick={() => setModalShowStep1(true)}
            >
              <s.Text>New Account</s.Text>
            </s.MenuItem>
          </Link>
        </s.ItemContainer>
        </s.MenuItemContainer>
        <CreateAccountModal
          show={modalShowStep1}
          onHide={() => setModalShowStep1(false)}
        />
        <CreateAccountModalStep2
          show={modalShowStep2}
          onHide={() => setModalShowStep2(false)}
        />
        <CreateAccountModalStep3
          show={modalShowStep3}
          onHide={() => setModalShowStep3(false)}
        />
  </s.SidebarContainer>
  );
}

export default Sidebar